export namespace ForecastLocationSearch {
    export enum Type {
        IP,
        GPS,
    }
    
    export interface Options {
        ipAddress?: string;
        latitude?: number;
        longitude?: number;
    }
}